'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  left: -9999px;\n  top: -9999px;\n  &:checked ~ {\n    &:after {\n      opacity: 1 !important;\n    }\n  }\n  &:focus ~ {\n    outline: none;\n    border-color: #2fb699;\n    box-shadow: 0 0 10px #2fb699;\n  }\n'], ['\n  position: fixed;\n  left: -9999px;\n  top: -9999px;\n  &:checked ~ {\n    &:after {\n      opacity: 1 !important;\n    }\n  }\n  &:focus ~ {\n    outline: none;\n    border-color: #2fb699;\n    box-shadow: 0 0 10px #2fb699;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCheckbox = _styledComponents2.default.input(_templateObject);

exports.default = StyledCheckbox;
//# sourceMappingURL=StyledCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ../checkbox/lib/StyledCheckbox.js
// module id = 155
// module chunks = 0